import { render, staticRenderFns } from "./ItemGridWorkView.vue?vue&type=template&id=10d5b456&scoped=true&"
import script from "./ItemGridWorkView.vue?vue&type=script&lang=js&"
export * from "./ItemGridWorkView.vue?vue&type=script&lang=js&"
import style0 from "./ItemGridWorkView.vue?vue&type=style&index=0&id=10d5b456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d5b456",
  null
  
)

export default component.exports